import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import { helpers } from '#components/generics/js/styles.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    dimension
  ) => {
    const wrapper = closest(`.${helpers.xfiles.elements.xfiles_attach_draw}`, dimension)
    let canvas
    let width
    let height

    if (wrapper) {
      canvas = one(`.${helpers.xfiles.elements.xfiles_attach_draw_canvas}`, wrapper)
      width = one(`[type='range'][name='canvas_width']`, wrapper)
      height = one(`[type='range'][name='canvas_height']`, wrapper)

      if (width && height) {
        resize(canvas, Number(width.value), Number(height.value))
      }
    }
  }
})

const resize = (canvas, width, height) => {
  const w = Number(canvas.width)
  const h = Number(canvas.height)
  const ctx = canvas.getContext('2d')
  let d

  if (ctx) {
    d = ctx.getImageData(0, 0, width, height)
    canvas.width = width
    canvas.height = height

    if (d) {
      ctx.putImageData(d, 0, 0)

      if (width > w) {
        ctx.beginPath()
        ctx.fillStyle = '#FFFFFF'
        ctx.fillRect(w, 0, width - w, Number(canvas.height))
      }

      if (height > h) {
        ctx.beginPath()
        ctx.fillStyle = '#FFFFFF'
        ctx.fillRect(0, h, Number(canvas.width), height - h)
      }
    }
  }
}

export default button => {
  onInput.listen(button)
}